import { atom, useAtom } from "jotai";

const isOpenHouseDrawer = atom(false);
const OpenHouseDrawerUnit = atom(null);

const useOpenHouseDrawer = () => {
  const [isOpen, setIsOpen] = useAtom(isOpenHouseDrawer);
  const [unit, setUnit] = useAtom(OpenHouseDrawerUnit);

  const toggle = () => {
    if (isOpen) {
      // set null if closed.
      setUnit(null);
    }

    setIsOpen(!isOpen);
  };

  const open = (unit) => {
    setUnit(unit);
    setIsOpen(true);
  };
  const close = () => {
  setIsOpen(false);
  setUnit(null);
};


  return { toggle, open, isOpen, unit,close };
};

export { useOpenHouseDrawer };
